module.exports = __webpack_public_path__ + "static/media/galdisa_home_small.dc2f1cd0.mp4";